
<template>

  <div   ref="ToggleButton" class="ToggleButton"
       :class="{'Checked':m_Value==true||m_Value==1,'Disabled':m_Attribute.Enabled == false}"

       v-show="FinalVisible"
       @click="OnToggleButtonClick"
    >
      <div class="Circle"></div>
  </div>


</template>

<script>
    import Utility from '@/Common/Utility'
import TControlBase from '../Common/TControlBase'

    export default {
        data() {
            return {
                m_Value: false,

                m_Attribute: TControlBase.Attribute( {

                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    MaxLength: null
                }
                )
            };
        }
        ,
        props: [...TControlBase.BaseProps],


        computed: {
             
        }
        ,

        methods: {


            OnToggleButtonClick(e) {

                if (this.FinalEnabled == false) {
                    return;
                }

                if (
                    this.m_Value == true ||
                    this.m_Value == "true" || this.m_Value == "True" || this.m_Value == 1 || this.m_Value == "1" || this.m_Value == "on") {
                    this.m_Value = true;
                }
                else {
                    this.m_Value = false;
                }

                this.m_Value = !this.m_Value;

                this.$emit("input", this.m_Value);
                this.$emit("click", this.m_Value);
                this.$emit("change", this.m_Value);

                this.$forceUpdate();
            },

            UpdateElementByAttribute() {

            },



        },

        mounted() {
            this.DoOnMounted();
        },


        created() {
            TControlBase.call(this);

            //if (this.Attribute != null) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            //}

            //this.m_Value = this.value;

            //if (this.m_Value == "true" || this.m_Value == "True" || this.m_Value == 1 || this.m_Value == "1" || this.m_Value == "on") {
            //    this.m_Value = true;
            //}
            //else {
            //    this.m_Value = false;
            //}

            //this.m_Attribute.Enabled = true;
 
            //if (this.disabled == true || this.disabled == "true") {
            //    this.m_Attribute.Enabled = false;
            //}
        },

        watch: {

            //"Attribute.Enabled": function (newVal, oldVal) {
                
            //    this.m_Attribute.Enabled = newVal;
            //},

            //Attribute: function (newVal, oldVal) {
                
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            //},

            //nullable: function (newVal, oldVal) {
            //},

            //value: function (newVal, oldVal) {

            //    this.m_Value = newVal;

            //    if (this.m_Value == "true" || this.m_Value == "True" || this.m_Value == 1 || this.m_Value == "1" || this.m_Value == "on") {
            //        this.m_Value = true;
            //    }
            //    else {
            //        this.m_Value = false;
            //    }
            //},

            //disabled (newVal){
            //    if (newVal == true || newVal == "true") {
            //        this.m_Attribute.Enabled = false;
            //    }
            //    else {
            //        this.m_Attribute.Enabled = true;
            //    }
            //}

        }


    }
</script>

<style scoped>
    .ToggleButton{
        border-radius:20px;
        background-color:#999999;
        width:60px;
        height:20px;
        position:relative;
        cursor:pointer;
        display:inline-block;
    }

        .ToggleButton .Circle {
            border-radius: 50%;
            width: 30px;
            height: 30px;
            background-color: white;
            border:1px solid #e0e0e0;
            -webkit-box-shadow: -4px 3px 5px -4px rgba(0,0,0,0.98);
            box-shadow: -4px 3px 5px -4px rgba(0,0,0,0.98);
            position:absolute;
            left:0px;
            top:-5px;
            transition:left 0.05s ease-in;
        }


        .ToggleButton.Checked   {
            background-color: rgb(199,229,245);
        }

            .ToggleButton.Checked .Circle {
                position: absolute;
                left: 30px;
                border: 1px solid rgb(30,152,215);
                background-color: rgb(30,152,215);
            }

        .ToggleButton.Disabled {
            opacity: 0.5;
            cursor: default;
        }
</style>
